import { Injectable } from '@angular/core';
import { UtilService } from '@app/shared/services/util.service';
import {
    getCognitoErrorCode,
    isUnverifiedContactResetPasswordError
} from '@app/modules/auth/utils/cognito-error.util';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    constructor(private _utilService: UtilService) {}

    hasError(err: any, data?: string) {
        const errorCode = getCognitoErrorCode(err);

        switch (errorCode) {
            // Register Errors
            case 'UsernameExistsException':
                this._utilService.presentToast(
                    `El correo electrónico ${data} ya esta registrado.`,
                    'warning',
                    5000
                );
                break;

            // Login Errors
            case 'UserNotFoundException':
            case 'NotAuthorizedException':
                this._utilService.presentToast(
                    'Correo electrónico o contraseña incorrectos.',
                    'warning',
                    5000
                );
                break;

            // Forgot Password Errors
            case 'UserNotFoundException':
                this._utilService.presentToast(
                    `El correo ${data} no esta registrado.`,
                    'warning',
                    5000
                );
                break;

            case 'InvalidParameterException':
                if (isUnverifiedContactResetPasswordError(err)) {
                    this._utilService.presentToast(
                        'Tu cuenta no tiene un correo verificado. Contacta a soporte o a tu administrador.',
                        'error',
                        8000
                    );
                    break;
                }

                this._utilService.presentToast(
                    `No se puede restablecer la contraseña, falta verificar su dirección de correo electrónico`,
                    'error',
                    5000
                );
                break;

            case 'LimitExceededException':
                this._utilService.presentToast(
                    `Se ha superado el límite de intentos, por favor intente después de un tiempo.`,
                    'error',
                    5000
                );
                break;

            case 'CodeMismatchException':
                this._utilService.presentToast(
                    `El código de verificación no es válido, inténtalo de nuevo.`,
                    'warning',
                    5000
                );
                break;

            case 'ExpiredCodeException':
                this._utilService.presentToast(
                    `El código expiró. Solicita uno nuevo.`,
                    'warning',
                    5000
                );
                break;

            case 'UserNotConfirmedException':
                this._utilService.presentToast(
                    `La cuenta no está verificada. Ingresa primero el código de registro.`,
                    'warning',
                    7000
                );
                break;

            case 'UserAlreadyAuthenticatedException':
                this._utilService.presentToast(
                    'Ya hay una sesión activa. Recarga la página e intenta iniciar sesión de nuevo.',
                    'warning',
                    8000
                );
                break;

            // Default error
            default:
                this._utilService.presentToast(
                    `Fallo la solicitud intentalo más tarde.`,
                    'error',
                    5000
                );
                break;
        }
    }
}
